import React from "react";
import { Link } from "react-router-dom";

export const Breadcrumb = (props) => {
  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb pl-0">
        <li className="breadcrumb-item">
          <Link to="/dashboard-report">
            <i className="material-icons">home</i> Home
          </Link>
        </li>
        <li className="breadcrumb-item">
          <Link to="/category">Category</Link>
        </li>

        <li className="breadcrumb-item active" aria-current="page">
          Edit Category
        </li>
      </ol>
    </nav>
  );
};

export default Breadcrumb;
